import { FC } from 'react';
import { Stepper } from './Menu.styled';

export const Menu: FC<{ children?: React.ReactNode }> = ({ children }) => {
  return <Stepper>{children}</Stepper>;
};

export default Menu;
